import {withRouter} from 'react-router-dom'
import {inject, observer} from 'mobx-react'
import * as React from 'react'
import {Headlines, InnerContainer} from '../../../../shared/components/Elements'
import {Headline, SubHeadline} from '../../../../shared/components/Headlines'
import {ContentContainerBody, SplitContentContainer} from '../../../../shared/components/Content'
import {SideInformation} from '../../../../shared/components/SideInformation'
import {Button, ButtonBar, NextButton} from '../../../../shared/components/Button'
import {SegmentedProgressBar} from '../result/SegmentedProgressBar'
import {autobind} from 'core-decorators'
import {Jaw, JawTranslation} from '../../../../shared/Constants'
import {CalculatorStoreInstance} from '../../../../stores/CalculatorStore'
import {History} from 'history'
import {Utils} from "../../../../shared/Utils";
import {breakpoint, styled} from "../../../../shared/styled-components";
import {RadioButtonControl} from "../../../../shared/components/RadioButtonControl";

interface IProps {
  jaw: Jaw
  store?: CalculatorStoreInstance
  history?: History
}

@(withRouter as any)
@inject('store')
@observer
export class AllOn4TypeView extends React.Component<IProps> {

  // -------------------------------------------------------------------------- EVENTS

  @autobind
  private _onNextClick () {
    this.props.store!.goForward()
  }

  private _onFullReplacementChange (fullReplacementType: string) {
    const { store, jaw } = this.props
    const requirement = store.offer.getJawRequirement(jaw)
    requirement.setFullReplacementType(fullReplacementType)
  }

  // -------------------------------------------------------------------------- RENDERING
  render () {
    const { store, jaw } = this.props
    const requirement = store!.offer.getJawRequirement(jaw)

    return (<InnerContainer padded>
      <Headlines>
        <Headline centered>Unsere Empfehlung - {JawTranslation[jaw]}</Headline>
        <SubHeadline centered>Durch Ihre Auswahl empfehlen wir Ihnen folgenden Zahnersatz:</SubHeadline>
      </Headlines>

      <SplitContentContainer>
        <ContentContainerBody padded>
          <Top>
            <Left>
              <NoTeethImage src={Utils.getAssetPath(`/assets/calculator/${jaw}_jaw_all_on_4.png`)} />
            </Left>
            <Right>
              <div>
                <Headline>All-on-4®</Headline>
                <SubHeadline>Bitte Art der Versorgung wählen</SubHeadline>

                <Checkboxes>
                  <RadioButton
                      label='All-on-4®'
                      checked={requirement.fullReplacementType === 'all_on_4'}
                      onChange={this._onFullReplacementChange.bind(this, 'all_on_4')}
                      tooltip='Feste Zähne an einem Tag auf 4 Implantaten mit dem All-on-4®-Behandlungskonzept. Diese Art der Versorgung kann nicht immer und nur bei ausreichendem Restknochenangebot durchgeführt werden.' />
                  <RadioButton
                      label='All-on-6'
                      checked={requirement.fullReplacementType === 'all_on_6'}
                      onChange={this._onFullReplacementChange.bind(this, 'all_on_6')}
                      tooltip='Feste Zähne an einem Tag auf 6 Implantaten. Diese Art der Versorgung kann nicht immer und nur bei ausreichendem Restknochenangebot durchgeführt werden.' />
                </Checkboxes>
              </div>
            </Right>
          </Top>
          <SideInformation
              backButtonHidden={jaw === 'upper'}
              onBackClick={() => store!.goBack()}
              onNextClick={() => store!.goForward()}
              infoText={jaw === 'upper'
                  ? 'jeder Zahnarzt in Deutschland ca. 20 Implantate im Jahr setzt, der durchschnittliche implacheck®-Implantologe hingegen 300?'
                  : 'sogar die durchschnittliche Lebenserwartung von Patienten durch die verbesserte Kauleistung dank Implantaten ansteigt?'
              }
              longInfoText={jaw === 'upper'
                  ? 'jeder Zahnarzt in Deutschland ca. 20 Implantate im Jahr setzt, der durchschnittliche implacheck®-Implantologe hingegen 300? Unsere implacheck®-Implantologen durchlaufen einen Auswahlprozess, der einen einheitlichen Qualitätsstandard des Netzwerks sicherstellt. Auf der Unterseite der einzelnen Implantologen haben Sie die Möglichkeit die einzelnen Fachqualifikationen unserer Behandler nachzuvollziehen. Neben tadellosem Kundenservice und einer außerordentlichen Patientenfreundlichkeit versichern wir unseren Patienten durch das Auswahlverfahren auch ein ganzheitliches Behandlungsspektrum und eine Praxisausstattung in den Partnerpraxen, die den neuesten Standards entspricht. '
                  : 'sogar die durchschnittliche Lebenserwartung von Patienten durch die verbesserte Kauleistung dank Implantaten ansteigt? Dadurch, dass Implantatpatienten sich in Bezug auf die Nahrungsaufnahme nicht einschränken müssen und damit eine Verbesserung der allgemeinen Lebensqualität entsteht, steigt die Lebenserwartung erheblich. Auf unserer Website finden Sie weitere Informationen über die Vorteile von Implantatversorgungen.'
              }/>
        </ContentContainerBody>
      </SplitContentContainer>

      <ButtonBar>
        <Button onClick={() => store!.goBack()}>Zurück</Button>
        <SegmentedProgressBar segmentCount={2} segment={0} />
        <NextButton primary onClick={this._onNextClick}>Weiter</NextButton>
      </ButtonBar>
    </InnerContainer>)
  }
}

const Left = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
`
const Right = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0;
  justify-content: space-between;
  text-align: center;
  ${breakpoint('tablet')`
    flex: 0 0 350px;
    padding-left: 40px;
    text-align: left;
  `}
`

const ImageContainer = styled.div`
  flex: 0 0 300px;
  text-align: center;
  ${breakpoint('tablet')`
    text-align: left;
  `}
`

const Top = styled.div`
  display: flex;
  flex-direction: column-reverse;
  min-height: 400px;
  ${breakpoint('tablet')`
    flex-direction: row;
  `}
`

const NoTeethImage = styled.img`
  width: 100%;
  max-width: 376px;
`

const Checkboxes = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 25px;
`

const RadioButton = styled(RadioButtonControl)`
  margin-bottom: 10px;
`
